export default __webpack_public_path__ + "static/media/MercedesGle.626e6a20.jpg";